import React from "react";
import { useMenuContext } from "../../context/MenuContext";
import { HamburgerSlider } from "react-animated-burgers";

import classnames from "classnames";
import styles from "./MenuToggle.module.css";

interface IProps {
  className?: string;
}
const MenuToggle: React.FC<IProps> = ({ className }) => {
  const { showMenu, toggleShowMenu } = useMenuContext();

  return (
    <HamburgerSlider
      isActive={showMenu}
      toggleButton={toggleShowMenu}
      barColor="#FAF0E6"
      className={classnames(styles.MenuToggle, className)}
      buttonWidth={24}
    />
  );
};

export default MenuToggle;
